/* eslint-disable @typescript-eslint/no-explicit-any */
import IconConfig from '@assets/icons/config.svg?react';
import { Box, IconButton, Theme, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useFieldsConfig } from '../../../contexts/useFieldsConfigDialog';
import { usePage } from '../../../contexts/usePageContext';
import { setConfigStorageItem } from '../../../hooks/useConfigStorage';
import { RootState } from '../../../redux/store';
import customColors from '../../../utils/customColors';
import { findStructure, getTranslation } from '../../../utils/dataTypes';
import { titleStyles } from '../../common/InfoSidebar/infoStyles';

const InfoFavorites = ({ data }: { data: any }) => {
 const { pageName } = usePage();
 const { openDialog: openFieldsConfigDialog } = useFieldsConfig();
 const { t } = useTranslation();
 const fieldPresets = useSelector(
  (state: RootState) => state.clientConfiguration.fieldPresets,
 );

 const structure = useSelector((state: RootState) => {
  if (pageName) {
   const pageState = state[pageName as keyof RootState];
   if (pageState && typeof pageState === 'object' && 'structure' in pageState) {
    return pageState.structure;
   }
  }
  return null;
 });

 const [fields, setFields] = useState<string[]>([]);

 const fieldsWithData = useMemo(() => {
  if (!structure || !Array.isArray(fields)) return [];
  return fields?.map((field) => {
   const val = field.split('.').reduce((acc, part) => acc?.[part], data);
   const str = findStructure(structure, field);
   return {
    Key: field,
    Translation: getTranslation(structure, field),
    Value: str?.Type === 'array' ? 'no array support' : val,
   };
  });
 }, [fields, data, structure]);

 useEffect(() => {
  const tableSidebarFields =
   typeof fieldPresets === 'object' && fieldPresets !== null && pageName
    ? fieldPresets[pageName]?.sidebar
    : undefined;

  if (tableSidebarFields) {
   setConfigStorageItem({
    page: pageName,
    key: 'favorites_sidebar',
    value: tableSidebarFields,
   });
   setFields(tableSidebarFields);
  }
 }, [fieldPresets]);

 return (
  <Box>
   <Typography
    sx={{
     ...titleStyles,
     mb: 2,
     display: 'flex',
     alignItems: 'center',
     gap: 1,
     justifyContent: 'space-between',
    }}
   >
    {t('global.favorites')}
    <IconButton onClick={() => openFieldsConfigDialog({ type: 'sidebar' })}>
     <IconConfig />
    </IconButton>
   </Typography>
   {!fieldsWithData.length && (
    <Box
     sx={{
      textAlign: 'center',
      p: '12px',
      backgroundColor: (theme: Theme) => theme.palette.kemek.lightBlue,
      mb: 3,
     }}
    >
     <Typography variant="body2" color="text.secondary">
      {t('global.noItemsFound')}
     </Typography>
    </Box>
   )}
   {fieldsWithData?.length > 0 && (
    <Box
     sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      border: `1px solid ${customColors?.lightestGray}`,
      borderRadius: 1,
      p: 2,
      mb: 3,
     }}
    >
     {fieldsWithData.map((item) => (
      <Box key={item.Key}>
       <Box
        sx={{
         display: 'flex',
         gap: 1, //   alignItems: 'center',
         justifyContent: 'space-between',
        }}
       >
        <Typography
         component="span"
         sx={{
          fontWeight: 'medium',
          fontSize: 12,
          //  color: !item.Value ? customColors.gray : 'inherit',
         }}
        >
         {item.Translation}
        </Typography>
        <Typography sx={{ fontSize: 12, textAlign: 'right' }}>
         {item.Value === null ? '-' : item.Value}
        </Typography>
       </Box>
      </Box>
     ))}
    </Box>
   )}
  </Box>
 );
};

export default InfoFavorites;
